/**
 * Testimonial Slider — Splide.js fade carousel
 */
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

export const testimonialSlider = {
    selector: '.js-testimonial-slider',

    init() {
        document.querySelectorAll( this.selector ).forEach( el => {
            const slides = el.querySelectorAll( '.splide__slide' );
            if ( slides.length <= 1 ) return;

            const section = el.closest( 'section' );
            const prevBtn = section?.querySelector( '.splide-arrow-prev' );
            const nextBtn = section?.querySelector( '.splide-arrow-next' );

            const splide = new Splide( el, {
                type:       'fade',
                rewind:     true,
                pagination: false,
                arrows:     false,
                autoHeight: true,
                speed:      600,
            } ).mount();

            prevBtn?.addEventListener( 'click', () => splide.go( '<' ) );
            nextBtn?.addEventListener( 'click', () => splide.go( '>' ) );
        } );
    },
};
